import IcDownload from './ADSProductDownload.svg'
import useDownloadImage from "../../../../../../../../hooks/useDownloadImage";

const ADSProductDownload = ({product}) => {
  const downloadImage = useDownloadImage()

  const handleDownloadProduct = (e) => {
    e.stopPropagation();
    downloadImage({
      path: product.imageUrl,
      filename: product.name,
    })
  }

  return (
    <img src={IcDownload} alt='download-product' onClick={handleDownloadProduct} style={{width: 18, height: 18}} />
  );
};

export default ADSProductDownload;
